// eslint-disable-next-line import/no-anonymous-default-export
export default {
  screens: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1904px',
  },
};
